import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n, { detectBrowserLocale } from '@/utils/i18n'; //多语言
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/components/icons' // icon
import '@/styles/index.scss' // global css
import dayjs from "dayjs"; //时间戳转换
import {sha256} from 'js-sha256';
// 共用库
import "cloudcc-ccdk/lib/ccdk.min.js";
// 创建Event Bus
Vue.prototype.$bus = new Vue()
// 兼容老版本
Vue.prototype.$Bus = Vue.prototype.$bus
import http from './utils/http'
Vue.config.productionTip = false
Vue.prototype.dayjs = dayjs; //可以全局使用dayjs
Vue.prototype.$sha256 = sha256;
// 网络请求对象
Vue.prototype.$http = http
Vue.use(ElementUI)

// 禁止浏览器自动恢复滚动位置，交由路由控制
if ('scrollRestoration' in window.history) {
  try {
    window.history.scrollRestoration = 'manual'
  } catch (e) {
    // ignore
  }
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

// 运行时语言：根据浏览器语言切换，但在预渲染环境（HeadlessChrome）下保持中文
try {
  const ua = (typeof navigator !== 'undefined' && navigator.userAgent) ? navigator.userAgent : ''
  const isPrerender = ua.includes('HeadlessChrome')
  if (!isPrerender) {
    const browserLocale = detectBrowserLocale()
    if (browserLocale && i18n.locale !== browserLocale) {
      i18n.locale = browserLocale
    }
  }
} catch (e) {}

// 预渲染：应用与路由就绪后触发事件供 Puppeteer 渲染
if (process.env.NODE_ENV === 'production' && router && typeof router.onReady === 'function') {
  router.onReady(() => {
    document.dispatchEvent(new Event('render-event'))
  })
  // 兜底：即便上面事件因异常未触发，也在4秒后强制触发一次
  setTimeout(() => {
    try {
      document.dispatchEvent(new Event('render-event'))
    } catch (e) {}
  }, 4000)
}
